export const CSS_CLASS = {
  focusedEmptyParagraph: 'focused-empty-paragraph',
  scoreHoverableParent: 'score-hoverable-parent',
  notranslate: 'notranslate',
} as const;

export const ELEMENT_ID = {
  accountDetails: 'accountDetails',
  documentBriefForm: 'documentBriefForm',
} as const;
